import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ModalConfirmV2, ModalSizeVariants } from '@labrav/react-components'
import { Typography } from '@mui/material'
import React from 'react'

export type DeleteAuthorizationModalProps = {
  open: boolean
  acceptLoading: boolean
  onAccept: () => void
  onDecline: () => void
}

export const DeleteAuthorizationModal = ({
  open,
  acceptLoading,
  onAccept,
  onDecline,
}: DeleteAuthorizationModalProps) => (
  <ModalConfirmV2
    title={'Delete this authorization? '}
    description={
      <Typography>
        <p>
          You will not be able to recover this authorization or any information
          inside it once this authorization is deleted.
        </p>

        <p>Are you sure you want to delete this Reseller authorization?</p>
      </Typography>
    }
    open={open}
    titleAcceptButton={'Delete'}
    onAccept={onAccept}
    acceptLoading={acceptLoading}
    onDecline={onDecline}
    variant={ModalSizeVariants.small}
    icon={
      <FontAwesomeIcon
        icon={faTrash}
        style={{ width: '14px', height: '16px' }}
      />
    }
    hideCancelIcon={false}
    hideCancelButton={false}
  />
)
